<template>
  <v-container class="pa-2">
    <v-row class="justify-center">
      <v-col lg="10" xl="8">
        <div v-if="joinAvatar.text" style="float: right; margin-top: 20px">
          <v-avatar :color="joinAvatar.color" class="ml-md-5">
            <span class="font-weight-medium" style="color: white">
              {{ joinAvatar.text }}
            </span>
          </v-avatar>
          <span class="pl-2" v-bind:style="brandedTextClass">
            {{ joinAvatar.userName }}
          </span>
        </div>
        <h1 class="text-center my-5" v-bind:style="brandedTextClass">
          {{ $store.state.event.name }}
        </h1>

        <div v-for="date in dates" :key="date.date">
          <h3 class="mb-1 mt-6" v-if="date.showDate" v-bind:style="brandedTextClass">{{ date.date | datetime_2 }}</h3>
          <h3 class="mb-1 mt-6" v-if="!date.date" v-bind:style="brandedTextClass">{{ $t("participant.lobby.replay") }}</h3>
          <v-card class="my-2">
            <v-card-text>
              <v-row class="align-start" dense>
                <v-col cols="12" sm="3" md="2" class="text-center align-self-center">
                  <div class="text-subtitle-2 d-none d-sm-block" v-if="date.date">
                    {{ $t("participant.lobby.startsAt") }}
                  </div>
                  <div class="text-h4" v-if="date.date">{{ date.date | time }}</div>
                  <div class="text-subtitle-2" v-if="date.date" :title="$t('participant.lobby.duration')">
                    <v-icon small class="mr-1">mdi-alarm</v-icon>{{ date.duration | duration }}
                  </div>
                  <div v-if="!date.date">
                    <v-icon x-large :title="$t('participant.lobby.replay')">mdi-clipboard-play-outline</v-icon>
                  </div>
                </v-col>
                <v-col cols="12" sm="9" md="10">
                  <v-row class="activity" no-gutters v-for="(activity, index) in date.activities" :key="activity.id">
                    <v-col cols="12" v-if="index" class="py-4"><v-divider horizontal /></v-col>
                    <v-col cols="12" md="9">
                      <h2 class="mb-2">
                        {{ activity.name }}
                      </h2>
                      <div class="caption">
                        {{ activity.description }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center align-self-center">
                      <ParticipantLobbyTimer :activity="activity"></ParticipantLobbyTimer>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ParticipantLobbyTimer from "./components/participant.lobby.timer";
import randomMC from "random-material-color";

export default {
  components: { ParticipantLobbyTimer },
  data() {
    return {
      dates: [],
      joinAvatar: {},
    };
  },
  async mounted() {
    if (!this.$store.state.event.enableLobby) {
      this.$router.push({ name: "notFound" });
    }
    this.dates = await this.$axios.get(`/event/${this.$store.state.event.id}/lobby`, {
      params: {},
    });
    if (this.$route.query.userName && this.$route.query.firstName && this.$route.query.lastName) {
      this.joinAvatar.text = this.$route.query.firstName.substr(0, 1) + this.$route.query.lastName.substr(0, 1);
      this.joinAvatar.color = this.getColor();
      this.joinAvatar.userName = this.$route.query.userName;
    }
  },
  methods: {
    getColor() {
      return randomMC.getColor({ shades: ["500", "600", "700"] });
    },
  },
  computed: {
    brandedTextClass() {
      return {
        color: this.$store.state.event.brandingTextColor,
      };
    },
  },
};
</script>
